import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { SkapaTokens, SkapaText } from '@inter-ikea-guida/skapa';
import { useGuidaUIStates } from '../hooks/useGuidaUIStates';
const StyledLabel = styled.label `
  display: block;
  margin-bottom: ${SkapaTokens.space50};
`;
export const GuidaLabel = ({ text, htmlFor, className }) => {
    const { isCompact } = useGuidaUIStates();
    return (_jsx(StyledLabel, { htmlFor: htmlFor, className: className, children: _jsx(SkapaText, { tagName: 'span', textStyle: isCompact ? 'Heading.XS' : 'Heading.S', children: text }) }));
};
//# sourceMappingURL=GuidaLabel.js.map